// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ current: NonNullable<unknown>, max: NonNullable<unknown> }} i
*/
export const messageBroadcast_characters = (i) => `Characters: ${i.current}/${i.max}`